
import Backbone from 'backbone'
import Cocktail from 'backbone.cocktail'
import ElementCollection from '../collections/ElementCollection'
import MapModelMixin from './mixins/MapModelMixin'

class LayerModel extends Backbone.Model {

  initialize(attributes, options) {
    this.set({
      elements: new ElementCollection(this.get('elements'), options)
    })
  }
}

Cocktail.mixin(LayerModel, MapModelMixin)

export default LayerModel
